import React from "react";
import { Link } from "react-router-dom";
import '../index.css';

const Blog = () => {
  return (
    <div className="middle-section">
      <div className="blog-content">
        <div className="section-header">
          <h2 className="section-title">blog</h2>
          <div className="title-line"></div>
        </div>
        <Link className="blog-link" to="/blog/gitcheck">
          <div className="blog-content-bar">
            <p className="blog-name">GitHub OAuth & API Integration Deep Dive</p>
            <div className="c-lesPJm c-lesPJm-ictlqdw-css"></div>
            <p className="blog-year">November 26, 2025</p>
          </div>
        </Link>

        <Link className="blog-link" to="/blog/react-patterns">
          <div className="blog-content-bar">
            <p className="blog-name">Modern React Patterns: Hooks & Composition</p>
            <div className="c-lesPJm c-lesPJm-ictlqdw-css"></div>
            <p className="blog-year">November 17, 2025</p>
          </div>
        </Link>

        <Link className="blog-link" to="/blog/scss-architecture">
          <div className="blog-content-bar">
            <p className="blog-name">SCSS Architecture: Scalable Styles for Large Projects</p>
            <div className="c-lesPJm c-lesPJm-ictlqdw-css"></div>
            <p className="blog-year">September 2, 2025</p>
          </div>
        </Link>

        <Link className="blog-link" to="/blog/sass-tips">
          <div className="blog-content-bar">
            <p className="blog-name">SASS Tips & Tricks: Functions, Mixins and Maps</p>
            <div className="c-lesPJm c-lesPJm-ictlqdw-css"></div>
            <p className="blog-year">June 10, 2025</p>
          </div>
        </Link>

        <Link className="blog-link" to="/blog/bem-best-practices">
          <div className="blog-content-bar">
            <p className="blog-name">BEM Best Practices: Naming that Scales</p>
            <div className="c-lesPJm c-lesPJm-ictlqdw-css"></div>
            <p className="blog-year">March 18, 2025</p>
          </div>
        </Link>

        <Link className="blog-link" to="/blog/bemit-guide">
          <div className="blog-content-bar">
            <p className="blog-name">BEMIT Explained: A Pragmatic Utility Approach</p>
            <div className="c-lesPJm c-lesPJm-ictlqdw-css"></div>
            <p className="blog-year">January 5, 2025</p>
          </div>
        </Link>

        <Link className="blog-link" to="/blog/frontend-performance">
          <div className="blog-content-bar">
            <p className="blog-name">Frontend Performance: Critical Rendering & Optimizations</p>
            <div className="c-lesPJm c-lesPJm-ictlqdw-css"></div>
            <p className="blog-year">November 20, 2024</p>
          </div>
        </Link>      

      </div>
    </div>
  );
}

export default Blog;
